var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10px"}},[_c('v-row',_vm._l((_vm.overviewIcon),function(item,index){return _c('v-col',{key:'Overview' + index,attrs:{"cols":"6","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('cardmenus',{attrs:{"cardData":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }